module.exports = __webpack_public_path__ + "static/media/linux-64-icon.b794ca9f.svg";